<template>
  <div class="candidate-group-selector">
    <el-input
      v-if="isAdd"
      v-model="newGroupName"
      clearable
      class="new-group-name"
      @change="handleNewGroupNameChange"
    />
    <el-select
      v-else
      v-model="selectGroup"
      filterable
      clearable
      class="group-select"
      value-key="id"
      @change="handleSelectGroupChange"
    >
      <el-option
        v-for="(group, index) in groupList"
        :key="index"
        :label="group.text"
        :value="group"
      />
    </el-select>
    <el-button class="change-mode-btn" type="text" @click="handleChangeModeBtnClick">{{ $t(`${i18nPrefix}.btn.${isAdd ? 'toExistedGroup' : 'toNewGroup'}` )}}</el-button>
  </div>
</template>

<script>
import emitter from 'element-ui/src/mixins/emitter'

export default {
  mixins: [emitter],
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Object
    },
    groupList: {
      type: Array,
      required: true
    },
    defaultIsAddNewGroup: {
      type: Boolean,
      default: false
    },
    defaultSelectGroupId: {
      type: Number
    },
    defaultSelectName: {
      type: String
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.candidateGroup',
      isAdd: this.defaultIsAddNewGroup,
      newGroupName: this.defaultSelectName,
      selectGroup: this.defaultSelectGroupId
    }
  },
  computed: {

  },
  created () {

  },
  methods: {
    emitGroupInfo (groupId, groupName) {
      const groupInfo = { id: groupId, text: groupName }
      this.$emit('change', groupInfo)
      this.dispatch('ElFormItem', 'el.form.change', groupInfo)
    },
    resetGroupInfo () {
      this.isAdd = this.defaultIsAddNewGroup
      this.newGroupName = this.defaultSelectName
      this.selectGroup = this.defaultSelectGroupId
    },
    handleNewGroupNameChange () {
      this.emitGroupInfo(null, this.newGroupName)
    },
    handleSelectGroupChange () {
      this.emitGroupInfo(this.selectGroup?.id, this.selectGroup?.text)
    },
    handleChangeModeBtnClick () {
      this.isAdd = !this.isAdd
      this.newGroupName = null
      this.selectGroup = null
      this.emitGroupInfo()
    }
  },
  watch: {
    value () {
      if (!this.value) {
        this.resetGroupInfo()
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
